import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import AccountInfo from './AccountInfo';
import SubscriptionInfo from './SubscriptionInfo';
import SearchActivity from './SearchActivity';
import SidebarNav from './SidebarNav';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="dashboard bg-light min-vh-100">
      <Container fluid className="py-4">
        <Row>
          <Col xs={12}>
            <div className="dashboard-header mb-4 ps-lg-3">
              <h1 className="fw-bold">Welcome back, {user?.first_name || 'User'}!</h1>
              <p className="text-muted">Here's an overview of your Pouncer account</p>
            </div>
          </Col>
        </Row>
        {/* Tabs navigation across the top */}
        <Row>
          <Col xs={12}>
            <SidebarNav />
          </Col>
        </Row>
        <Row className="gx-0 gx-lg-4">
          <Col xs={12} lg={8} className="d-flex flex-column">
            <SearchActivity />
          </Col>
          <Col xs={12} lg={4} className="d-flex flex-column gap-4">
            <AccountInfo />
            <SubscriptionInfo />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
